import React from "react";
import { Checkbox } from "@/components/Calendar/ui/checkbox";
import { blockOutTypes } from "@/components/Calendar/scheduleData";

interface BlockOutTypesFilterProps {
  selectedBlockOutTypes: string[];
  onBlockOutTypeChange: (type: string, checked: boolean) => void;
  onSelectAll: (checked: boolean) => void;
  isDarkMode?: boolean;
}

export function BlockOutTypesFilter({
  selectedBlockOutTypes,
  onBlockOutTypeChange,
  onSelectAll,
  isDarkMode = false,
}: BlockOutTypesFilterProps) {
  const sortedBlockOutTypes = React.useMemo(() => {
    return [...(blockOutTypes || [])].sort((a, b) =>
      String(a.label || "").localeCompare(String(b.label || ""), undefined, {
        sensitivity: "base",
        numeric: true,
      }),
    );
  }, []);

  return (
    <div
      className={`rounded-lg border p-4 transition-colors duration-300 ${
        isDarkMode ? "bg-gray-700 border-gray-600" : "bg-white border-gray-200"
      }`}
    >
      <h4
        className={`text-sm font-semibold mb-3 transition-colors duration-300 ${
          isDarkMode ? "text-white" : "text-gray-900"
        }`}
      >
        Block-Out Types
      </h4>
      <div className="space-y-3">
        <div className="flex items-center space-x-2">
          <Checkbox
            id="select-all-blockouts"
            checked={
              selectedBlockOutTypes.length === sortedBlockOutTypes.length &&
              sortedBlockOutTypes.length > 0
            }
            onCheckedChange={onSelectAll}
          />
          <label
            htmlFor="select-all-blockouts"
            className={`text-sm cursor-pointer transition-colors duration-300 ${
              isDarkMode ? "text-gray-400" : "text-gray-500"
            }`}
          >
            Select All
          </label>
        </div>
        <hr
          className={`transition-colors duration-300 ${
            isDarkMode ? "border-gray-600" : "border-gray-200"
          }`}
        />
        {sortedBlockOutTypes.map((type) => (
          <div key={type.value} className="flex items-center space-x-2">
            <Checkbox
              id={`blockout-${type.value}`}
              checked={selectedBlockOutTypes.includes(type.value)}
              onCheckedChange={(checked) =>
                onBlockOutTypeChange(type.value, !!checked)
              }
            />
            <div
              className={`w-3 h-3 rounded-sm ${type.color} relative overflow-hidden`}
              style={{
                backgroundImage: `repeating-linear-gradient(
                  45deg,
                  transparent,
                  transparent 1px,
                  rgba(255,255,255,0.4) 1px,
                  rgba(255,255,255,0.4) 2px
                )`,
              }}
            ></div>
            <label
              htmlFor={`blockout-${type.value}`}
              className={`text-sm cursor-pointer transition-colors duration-300 ${
                isDarkMode ? "text-gray-300" : "text-gray-700"
              }`}
            >
              {type.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}
